import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { isEditingProject } from '../viewstate';
import loc from 'owa-localize';
import { creatingBoardLabel, updatingBoardLabel } from './BoardEditorStrings.locstring.json';

export default observer(function BoardEditorSaving() {
    return (
        <div className={styles.loadingContainer}>
            <Spinner
                size={SpinnerSize.large}
                label={isEditingProject() ? loc(updatingBoardLabel) : loc(creatingBoardLabel)}
            />
        </div>
    );
});
